import React from "react";
import "./styles.css";
import "./Search.css";
export default function TodayDate(props) {
    let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"  ];
    let day = days[props.date.getDay()];
  let months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"  ];
  
  let month = months[props.date.getMonth()];
  let year= props.date.getFullYear();
 let  dayDay = (new Date()).getDate();
  let monthDate = `${dayDay} ${month} ${year}`;
  
  let hours = props.date.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }
  
  let minutes = props.date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  return (
    <div>
              
              <h2 className="day-today">{day}</h2>              
              <p className="date-today">{monthDate}</p>              
              <p className="time-today"> Last updated{""} {hours}:{minutes}</p>
            </div>   
  );
}
  